import { render, staticRenderFns } from "./KennaSecurity.vue?vue&type=template&id=45c3ca98&"
import script from "./KennaSecurity.vue?vue&type=script&lang=js&"
export * from "./KennaSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports